/**
 * AMAÇ: <head>'deki meta/canonical etiketlerini route değişince güncelleyen ortak yardımcılar.
 * LandingPage (dil sürümleri) ve LegalPage (gizlilik/koşullar) tarafından kullanılır —
 * her ikisi de aynı DOM manipülasyonuna ihtiyaç duyar.
 */
export function setMetaTag(attr, key, content) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export function setCanonical(url) {
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.rel = 'canonical';
    document.head.appendChild(canonical);
  }
  canonical.href = url;
}

/**
 * <head>'e hreflang alternate linkleri ekler — önce eskilerini temizler (route
 * değişince yinelenmesinler diye), sonra verilen listeyi ekler.
 * GİRİŞ: [{ hreflang: 'en', href: '...' }, ..., { hreflang: 'x-default', href: '...' }]
 * DÖNÜŞ: temizleme fonksiyonu (useEffect'in return'ünde kullanılır)
 */
export function setHreflangAlternates(alternates) {
  document.querySelectorAll('link[rel="alternate"][hreflang]').forEach((el) => el.remove());
  const added = alternates.map(({ hreflang, href }) => {
    const el = document.createElement('link');
    el.rel = 'alternate';
    el.hreflang = hreflang;
    el.href = href;
    document.head.appendChild(el);
    return el;
  });
  return () => added.forEach((el) => el.remove());
}
